import { call, put, takeLatest, fork, all } from 'redux-saga/effects'
import get from 'lodash/fp/get'
import { createRoutineSaga, SAGA_WATCHER_LATEST_MODE } from '../../utils/saga'
import injectSaga from '../../state/hoc/injectSaga'

import { setToken } from '../Login/actions'
import api from './api'
import { verificationRoutine } from './routines'

export function * verifiSaga(token) {
  const loginToken = yield call(api.verify, token)

  return loginToken
}

function * onVerifySuccess({ payload: token }) {
  yield put(setToken(token))
}

export const { watcher, saga } = createRoutineSaga({
  routine: verificationRoutine,
  requestSaga: verifiSaga,
  requestArgsCreator: get('payload'),
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

export function * watchOnVerifiySuccess() {
  yield takeLatest(verificationRoutine.SUCCESS, onVerifySuccess)
}

export function * accountVerificationSaga() {
  yield all([
    fork(watcher),
    fork(watchOnVerifiySuccess)
  ])
}

export const withSaga = injectSaga({
  key: 'accountVerification',
  saga: accountVerificationSaga
})
